import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Button } from '../StyledComponents';

const FontSkip = ({
  nextStep,
  show
}) => {

  return (
    <StyledContainer
      className="status-bar"
      initial={{ right: -450 }}
      animate={{
        right: show ? '0px' : '-450px',
      }}
    >
      <div className="column">
        <h4>Use Default Font</h4>
        <Button onClick={nextStep}>
          Skip to Next Step
        </Button>
      </div>
    </StyledContainer>
  );
};

const StyledContainer = styled(motion.div)`
  position: fixed;
  top: 145px;
  padding: 20px;
  background-color: #ffffffee;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 0px 0 5px 3px rgba(0, 0, 0, 0.25);
  z-index: 1000;

  @media (max-width: 767px) {
    padding: 8px;
    top: 450px;
    width: 75px;

    h4 {
        font-size: 1.2rem;
    }

    button {
      padding: 0.75rem 0;
      width: 100%;
      text-align: center;
      font-size: 0.8rem;
    }
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 6px;

    h4 {
        margin: 0;
        font-size: 1.5rem;
        text-align: center;
    }



    @media (max-width: 767px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  p {
    margin: 0.5rem;
    text-align: center;

    i {
      font-weight: 200;
    }
  }
`;

export default FontSkip;
